var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_16458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7554 1.6875H15.2768L9.76964 7.88203L16.2482 16.3125H11.1768L7.20179 11.2008L2.65893 16.3125H0.133929L6.02321 9.68555L-0.1875 1.6875H5.0125L8.60179 6.35977L12.7554 1.6875ZM11.8696 14.8289H13.2661L4.25179 3.09375H2.75179L11.8696 14.8289Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_16458"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXShare);
export default __webpack_public_path__ + "static/media/x_share.3f89f06f6fdef61c42dcf9618186a2b8.svg";
export { ForwardRef as ReactComponent };